import Ajv2020 from 'ajv/dist/2020.js';
import addFormats from 'ajv-formats';
import { initLogger } from '../../logger.js';
export class JsonSchemaValidator {
    constructor(schemaDirectory, pattern, debug = false) {
        this.logger = initLogger(debug, 'json-schema-validator');
        this.pattern = pattern;
        this.logger.debug('Initialising JSON Schema Validator.');
        const strictType = debug ? 'log' : false;
        this.ajv = new Ajv2020({
            strict: strictType,
            allErrors: true,
            loadSchema: async (schemaId) => {
                this.logger.debug(`AJV is loading missing schema with ID: ${schemaId} from schema directory.`);
                try {
                    const schema = await schemaDirectory.getSchema(schemaId);
                    if (!schema) {
                        throw new Error(`Schema with ID '${schemaId}' could not be found in the schema directory.`);
                    }
                    return schema;
                }
                catch (error) {
                    this.logger.error(`Error fetching schema from schema directory: ${error}`);
                    throw error;
                }
            }
        });
        addFormats(this.ajv);
    }
    async initialize() {
        this.validateFn = await this.ajv.compileAsync(this.pattern);
    }
    validate(instance) {
        if (!this.validateFn) {
            throw new Error('Validator has not been initialized. Call initialize() before validating.');
        }
        this.logger.debug('Validating instance against JSON Schema.');
        const valid = this.validateFn(instance);
        if (valid) {
            return [];
        }
        else {
            return this.validateFn.errors || [];
        }
    }
}
//# sourceMappingURL=json-schema-validator.js.map